import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isProductPopUp: false,
  isProductId: "",
};

const productDetailsSlice = createSlice({
  name: "productDetailsSlice",
  initialState,
  reducers: {
    setIsProductPopUp: (state, action) => {
      state.isProductPopUp = action.payload;
    },
  },
});

export const { setIsProductPopUp } = productDetailsSlice.actions;

export default productDetailsSlice.reducer;
